'use strict';


function show_tyre_popup() {
    
    // set variables
    var facet = $('#facet'),
        $filterPopup = $('.filter-popup'),
        $boxPopup = $('.popup-box');
    
        //zresetujem hodnoty, vydz len tie co nasleduju, vratane aktualneho
    facet.find('input[name=p_type]').attr('checked', false);
    facet.find('input[name=p_season]').attr('checked', false);
    facet.find('input[name=p_width]').attr('checked', false);
    facet.find('input[name=p_height]').attr('checked', false);
    facet.find('input[name=p_radius]').attr('checked', false);            
    facet.find('input[name=p_type][value="' + p_type + '"]').attr('checked', true);
        
    $.ajax ({
        type: "GET",
        url: c3site.product.filter.urlExtended,
        dataType: "json",
        success: function(data)
        {
            // remove loading spinner
            $filterPopup.find('.fa-spin').remove();
            $boxPopup.css({'opacity': '1'});

            $('#pneu_type ul').empty('');                
            // APPEND JSON DATA IN PNEU SEZONA
            var field = "p_Param.type";
            var is_primary = data.fields[field].is_primary;
            $.each(data.fields[field].items, function(name) {
                var label = data.fields[field].items[name].label;
                $('#pneu_type ul').append("<li value='"+label+"' data-is-primary='"+is_primary+"'><a href='javascript:void(0)'>"+name+"</a></li>");
            });
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log('ERROR', textStatus, errorThrown);
        }
    });
    
    //zobrazim popup
    $('<div class="filter-background"></div>').prependTo('body');
    $('#pneu_na_automobil_filter').show();
}

function show_cars_popup () {
    
   // set variables
    var $filterPopup = $('.filter-popup'),
        $boxPopup = $('.popup-box');

    $filterPopup.append('<i class="fa fa-cog fa-spin fa-2x fa-fw"></i>');
    
        $.ajax ({
            type: "GET",
            url: c3site.product.filter.urlExtended2,
            dataType: "json",
            success: function(data)
            {
                // remove loading spinner
                $filterPopup.find('.fa-spin').remove();
                $boxPopup.css({'opacity': '1'});
        
                $('#car_brand ul').empty('');                
                // APPEND JSON DATA IN PNEU SEZONA
                
                $.each(data.car_brand, function(name) {
                    var label = data.car_brand[name].name;
                    $('#car_brand ul').append("<li class='"+name+"-logo' id='"+name+"' value='"+label+"' data-value='"+label+"' data-value-url='"+name+"'><a href='javascript:void(0)'>"+label+"</a></li>");
                });
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log('ERROR', textStatus, errorThrown);
            }
        });
    
    //zobrazim popup
    $('<div class="filter-background"></div>').prependTo('body');
    $('#cars_fitments_filter').show();
}

// popup filter loading after click on item
function popupLoading(start = true, selector) {
    if (start == true) {
        $(selector + ' .filter-list').css({'opacity': '.4'});
        if($(selector).find('.fa-spin').length == 0) {
            $(selector).append('<i class="fa fa-cog fa-spin fa-2x fa-fw spin--default"></i>');
        }
    } else {
        $(selector + ' .filter-list').addClass('active').css({'opacity': '1'});
        $(selector + ' ul').empty('');
        $(selector + ' .fa-spin').remove();
    }
}

$(document).ready(function() {
    
    // PNEU POPUP FILTER //////////////////////////////////////////////////////
    // ADD ACTIVE CLASS (TYP AUTOMOBILU) AFTER CLICK ON ELEMENT
    if(!$('#pneu_type li').hasClass('filter-active')) {
        $(document).on('click', '#pneu_type li', function() {
            $(this).addClass('filter-active').siblings().removeClass('filter-active');
            
            var facet = $('#facet');
            var p_type = $(this).attr('value');

            // loading
            popupLoading(true, '#pneu_season');
            
            //zresetujem hodnoty, vydz len tie co nasleduju, vratane aktualneho
            facet.find('input[name=p_type]').attr('checked', false);
            facet.find('input[name=p_season]').attr('checked', false);
            facet.find('input[name=p_width]').attr('checked', false);
            facet.find('input[name=p_height]').attr('checked', false);
            facet.find('input[name=p_radius]').attr('checked', false);            
            facet.find('input[name=p_type][value="' + p_type + '"]').attr('checked', true);
            
            $.ajax ({
                type: "GET",
                url: c3site.product.filter.urlExtended + "&" + c3site.product.filter.getParams(),
                dataType: "json",
                success: function(data)
                {
                    // stop loading
                    popupLoading(false, '#pneu_season');
                    
                    // APPEND JSON DATA IN PNEU SEZONA
                    var field = "p_Param.season";
                    var is_primary = data.fields[field].is_primary;
                    $.each(data.fields[field].items, function(name) {
                        var label = data.fields[field].items[name].label;
                        $('#pneu_season ul').append("<li value='"+label+"' data-is-primary='"+is_primary+"'><a href='javascript:void(0)'>"+name+"</a></li>");
                    });
                    c3site.product.filter.update();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('ERROR', textStatus, errorThrown);
                }
            });
        });
    }

    // ADD ACTIVE CLASS (SEZONA) AFTER CLICK ON ELEMENT
    if (!$('#pneu_season li').hasClass('filter-active')) {
        $(document).on('click', '#pneu_season li', function() {
            $(this).addClass('filter-active').siblings().removeClass('filter-active');
            
            var facet = $('#facet');
            var p_season =  $(this).attr('value');

            // loading
            popupLoading(true, '#pneu_width');
            
            //zresetujem hodnoty, vydz len tie co nasleduju, vratane aktualneho
            facet.find('input[name=p_season]').attr('checked', false);
            facet.find('input[name=p_width]').attr('checked', false);
            facet.find('input[name=p_height]').attr('checked', false);
            facet.find('input[name=p_radius]').attr('checked', false);            
            facet.find('input[name=p_season][value="' + p_season + '"]').attr('checked', true);
            
            $.ajax ({
                type: "GET",
                url: c3site.product.filter.urlExtended + "&" + c3site.product.filter.getParams(),
                dataType: "json",
                success: function(data)
                {
                    // stop loading
                    popupLoading(false, '#pneu_width');
                    
                    // APPEND JSON DATA IN PNEU SIRKA
                    var field = "p_Param.width";
                    var is_primary = data.fields[field].is_primary;
                    $.each(data.fields[field].items, function(name) {
                        var label = data.fields[field].items[name].label;
                        $('#sirka ul').append("<li value='"+label+"' data-is-primary='"+is_primary+"'><a href='javascript:void(0)'>"+name+"</a></li>");
                    });
                    c3site.product.filter.update();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('ERROR', textStatus, errorThrown);
                }
            });
        })
    }
    
    // ADD ACTIVE CLASS (SIRKA) AFTER CLICK ON ELEMENT
    if (!$('#sirka li').hasClass('filter-active')) {
        $(document).on('click', '#sirka li', function() {
            $(this).addClass('filter-active').siblings().removeClass('filter-active');
            
            var facet = $('#facet');
            var p_width =  $(this).attr('value');

            // loading
            popupLoading(true, '#pneu_height');
            
            //zresetujem hodnoty, vydz len tie co nasleduju, vratane aktualneho
            facet.find('input[name=p_width]').attr('checked', false);
            facet.find('input[name=p_height]').attr('checked', false);
            facet.find('input[name=p_radius]').attr('checked', false);
            facet.find('input[name=p_width][value="' + p_width + '"]').attr('checked', true);
            
            $.ajax ({
                type: "GET",
                url: c3site.product.filter.urlExtended + "&" + c3site.product.filter.getParams(),
                dataType: "json",
                success: function(data)
                {
                    // stop loading
                    popupLoading(false, '#pneu_height');
                    
                    // APPEND JSON DATA IN PNEU VYSKA
                    var field = "p_Param.height";
                    var is_primary = data.fields[field].is_primary;
                    $.each(data.fields[field].items, function(name) {
                        var label = data.fields[field].items[name].label;
                        $('#vyska ul').append("<li value='"+label+"' data-is-primary='"+is_primary+"'><a href='javascript:void(0)'>"+name+"</a></li>");
                    });
                    c3site.product.filter.update();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('ERROR', textStatus, errorThrown);
                }
            });
        })
    }
    
    if (!$('#vyska li').hasClass('filter-active')) {
        $(document).on('click', '#vyska li', function() {
            $(this).addClass('filter-active').siblings().removeClass('filter-active');
            
            var facet = $('#facet');
            var p_height =  $(this).attr('value');
                        
            //zresetujem hodnoty, vydz len tie co nasleduju, vratane aktualneho
            facet.find('input[name=p_height]').attr('checked', false);
            facet.find('input[name=p_radius]').attr('checked', false);            
            facet.find('input[name=p_height][value="' + p_height + '"]').attr('checked', true);
            
            $.ajax ({
                type: "GET",
                url: c3site.product.filter.urlExtended + "&" + c3site.product.filter.getParams(),
                dataType: "json",
                success: function(data)
                {
                    $('#pneu_radius #priemer').addClass('active');
                    $('#pneu_radius #priemer ul').empty('');
                    
                    // APPEND JSON DATA IN PNEU RADIUS
                    var field = "p_Param.radius";
                    var is_primary = data.fields[field].is_primary;
                    $.each(data.fields[field].items, function(name) {
                        var label = data.fields[field].items[name].label;
                        $('#priemer ul').append("<li value='"+label+"' data-is-primary='"+is_primary+"'><a href='javascript:void(0)'>"+name+"</a></li>");
                    });
                    c3site.product.filter.update();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('ERROR', textStatus, errorThrown);
                }
            });
        })
    }
    
    // ADD ACTIVE CLASS (PRIEMER) AFTER CLICK ON ELEMENT
    if(!$('#priemer li').hasClass('filter-active')) {
        $(document).on('click', '#priemer li', function() {
            $(this).addClass('filter-active').siblings().removeClass('filter-active');
  
            var facet = $('#facet');
            var p_radius =  $(this).attr('value');
            
            //zresetujem hodnoty, vydz len tie co nasleduju, vratane aktualneho
            facet.find('input[name=p_radius]').attr('checked', false);            
            facet.find('input[name=p_radius][value="' + p_radius + '"]').attr('checked', true);
            
            c3site.product.filter.update();
            
            // CLOSE POPUP FILTER
            $('.disky_na_automobil_filter, .pneu_na_automobil_filter').fadeOut('500');
                $('.filter-background').fadeOut('500').remove();
        });
    }
  // END OF PNEU POPUP FILTER //////////////////////////////////////////////////////
  
  // DISKY / SNEHOVE RETAZE / AKCIOVA SADA - POPUP FILTER //////////////////////////////////////////////////////
    
    // ADD ACTIVE CLASS (TYP AUTOMOBILU) AFTER CLICK ON ELEMENT
    if(!$('#car_brand li').hasClass('filter-active')) {
        $(document).on('click', '#car_brand li', function(evt) {
            $(this).addClass('filter-active').siblings().removeClass('filter-active');
            
            var car_brand_selected = $(this).data("value-url");
            var url = c3site.product.filter.urlExtended2
                url += "&car_brand=" + car_brand_selected;

            // loading
            popupLoading(true, '#car_model');

            $.ajax({
                url: url,
                dataType: "json",
                success: function(json) {

                    // stop loading
                    popupLoading(false, '#car_model');

                    // APPEND JSON DATA IN CAR MODEL
					var data = json.car_brand[car_brand_selected].car_model;
                    $.each(data, function(name) {
                        var label = data[name].name;
                        $('#car_model ul').append("<li id='"+name+"' value='"+label+"' data-value='"+label+"' data-value-url='"+name+"'><a href='javascript:void(0)'>"+label+"</a></li>");
                    });
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('ERROR', textStatus, errorThrown);
                }
            });
        })
    }

    // ADD ACTIVE CLASS (MODEL AUTOMOBILU) AFTER CLICK ON ELEMENT
    if(!$('#car_model li').hasClass('filter-active')) {
        $(document).on('click', '#car_model li', function(evt) {
            $(this).addClass('filter-active').siblings().removeClass('filter-active');
            var car_brand_selected = $('#car_brand li.filter-active').data("value-url");
            var car_model_selected = $(this).data("value-url");
            var url = c3site.product.filter.urlExtended2;
                url += "&car_brand=" + car_brand_selected;
                url += "&car_model=" + car_model_selected;

            // loading
            popupLoading(true, '#car_rada');

            $.ajax({
                url: url,
                dataType: "json",
                success: function(json) {
                    
                    // stop loading
                    popupLoading(false, '#car_rada');

                    // APPEND JSON DATA IN CAR MODEL
					var data = json.car_brand[car_brand_selected].car_model[car_model_selected].car_year;
                    $.each(data, function(name) {
                        var label = data[name].name;
                        $('#car_rada ul').append("<li id='"+name+"' value='"+label+"' data-value='"+label+"' data-value-url='"+name+"'><a href='javascript:void(0)'>"+label+"</a></li>");
                    });
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('ERROR', textStatus, errorThrown);
                }
            });
        })
    }
    
  // ADD ACTIVE CLASS (RADA AUTOMOBILU) AFTER CLICK ON ELEMENT
    if(!$('#car_rada li').hasClass('filter-active')) {
        $(document).on('click', '#car_rada li', function(evt) {
            $(this).addClass('filter-active').siblings().removeClass('filter-active');
            var car_brand_selected = $('#car_brand li.filter-active').data("value-url");
            var car_model_selected = $('#car_model li.filter-active').data("value-url");
            var car_year_selected = $(this).data("value-url");
            
            var car_brand_selected_name = $('#car_brand li.filter-active').data("value");
            var car_model_selected_name = $('#car_model li.filter-active').data("value");
            var car_year_selected_name = $(this).data("value");
            
            $('form#car_fitment').find("input[name='car_brand']").val(car_brand_selected_name);
            $('form#car_fitment').find("input[name='car_model']").val(car_model_selected_name);
            $('form#car_fitment').find("input[name='car_year']").val(car_year_selected_name);
            
            var url = c3site.product.filter.urlExtended2
                url += "&car_brand=" + car_brand_selected;
                url += "&car_model=" + car_model_selected;
                url += "&car_year=" + car_year_selected;
                
            $.ajax({
                url: url,
                dataType: "json",
                success: function(json) {
                    var image_path = cyclone3.domain + '/media/grf'
                    $('.car-detail-info #brand').append(car_brand_selected_name);
                    $('.car-detail-info #model').append(car_model_selected_name);
                    $('.car-detail-info #rada').append(car_year_selected_name);
                    $('.car-detail-image').attr('src', image_path + '/auto/' + car_brand_selected +'-'+ car_model_selected +'-'+ car_year_selected+'.png');
                    $('.car-detail-image').attr('alt', car_brand_selected_name + ' ' + car_model_selected_name + ', ' + car_year_selected_name);
                    $('.car-detail-logo').attr('alt', car_brand_selected_name);
                    $('.car-detail-logo').attr('src', image_path + '/logos/brands/' + car_brand_selected + '.png');
                    filterLoad('.disky_na_automobil_filter .col-sm-4.1-step', 1000, '.disky_na_automobil_filter .col-sm-12');
                    $('#cars_fitments_filter').css('overflow-y', 'scroll');
                    $('#detail_table').css('max-height','calc(100vh - 370px)');
                    // APPEND JSON DATA IN CAR DETAIL TABLE
                    var data = json.car_brand[car_brand_selected].car_model[car_model_selected].car_year[car_year_selected].car_type;
                    $.each(data, function(name) {
                        var label = data[name].name;
                            car_info = label.split("(");
                            car_info[1].replace(")", "");
                            car_info[1] = car_info[1].replace(")", "");
                            var tableBody = "<tr>"
                            + "<td><input type='checkbox' onclick='oneRow(this)' class='table-checkbox' value='"+label+"'/><label></label>"
                            + "<span>"+car_info[0]+"</span></td><td>"+car_info[1]+"</td></tr>";             
                        $('#detail_table').append(tableBody);
                    });
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('ERROR', textStatus, errorThrown);
                }
            });
        })
    }
    
    $(document).on('change', '#detail_table input', function(evt) {
        if($(this).is(":checked")) {
            $('form#car_fitment').find("input[name='car_type']").val($(this).val());
            $('#filter_final').removeAttr('disabled');
        } else {
            $('#filter_final').attr('disabled', true);
        }
    });
    
    // STEP BACK    
    $(document).on('click', '#step_back', function(evt) {
      $('.disky_na_automobil_filter .col-sm-12').hide();
      $('.disky_na_automobil_filter .col-sm-4.1-step').show();
      $('.car-detail-logo, .car-detail-image').attr('src', '');
      $('.car-detail-info #brand, .car-detail-info #rada, .car-detail-info #model, #detail_table').empty('');
      $('#filter_final').attr('disabled', true);
      $('#cars_fitments_filter').css('overflow-y', 'unset');
      $('#detail_table').css('max-height','calc(100vh - 450px)');
    });

    // SHOW RESULTS
    $(document).on('click', '#filter_final', function(evt) {
        if($(this).attr('disabled') != 'disabled') {
            $('form#car_fitment').submit();
        }
    });
    // SHOW RESULTS
    $(document).on('click', '#change_car_fitment', function(evt) {
        show_cars_popup();
    });
     // SHOW RESULTS
    $(document).on('click', '#remove_car_fitment', function(evt) {
         $('form#car_fitment_delete').submit();
    });
  // END OF DISKY POPUP FILTER //////////////////////////////////////////////////////
  






    //-------------------------------------------------------------------------//
    //                                FUNCTIONS                                //
    //-------------------------------------------------------------------------//

	// HIDE NEXT POPUP FILTER COLS ON CHANGE
	$('.filter-popup').on("click", "li", function() {
		  $(this).closest('.popup-box').next('.popup-box').nextAll('.popup-box').find('.filter-list').removeClass('active');
  })
  
  // hide filter popup box in click
  if($(window).width() < 768) {
    $(document).on('click', '.popup-box li', function() {
      var popupBox = $(this).closest('.popup-box');
      setTimeout(function() {
        popupBox.hide();
      }, 250);
    });
  }

    //    EXIT FILTER FUNCTION
    function hidePopupFilter() {
        $('.filter-popup').fadeOut('500');
        $('.filter-background').fadeOut('500');
    }

    // EXIT FILTER AFTER CLICK ON CLOSE BUTTON
    $(document).on('click', '.exit-filter, .filter-background', function() {
        hidePopupFilter();
    });
    // EXIT FILTER AFTER ESC KEY PRESS
    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            hidePopupFilter()
        }
    });


  // FULL TABLE ROW CLICKABLE
  $(document).on('click', 'tbody tr', function(event) {
      $(this).toggleClass('selected');
      if (event.target.type !== 'checkbox') {
          $(':checkbox', this).trigger('click');
      }
  });

  // add class 'open' to navigation on hamburger button click
  $('.navbar-toggle').on('click', function() {
    // set variables
    var nav = $('.navbar-collapse'),
        body = $('body');

    nav.toggleClass('open').hasClass('open') ? body.css({'overflow': 'hidden'}) : body.css({'overflow': 'initial'});
  });

  // DROPDOWN MOBILE MENU
  if($(window).width() <= 991) {

    $(document).on('click', '.navbar-nav .toggle-icon', function(e) {
      e.preventDefault();
      
      $(this).toggleClass('open').closest('a').next('.dropdown-menu').slideToggle('fast');
  	});
  };
  
  // KEEP DROPDOWN CLICABLE INSIDE
  $(document).on('click', '.dropdown-menu', function(e) {
      e.stopPropagation();
  });

  // CHECKED ONLY ONE CHECKBOX (defined by parent class "check-one-row"), (input must have same name="checkbox-{{name}}" - one specific name for one table)
  $(document).on('change', '.check-one-row input:checkbox', function(event) {
      var th = $(this), name = th.prop('name'),value = th.prop('value');      
      if(th.is(':checked')){
        $(':checkbox[name="' + name + '"]').not($(this)).prop('checked',false);   
        th.parents('.btn-group').find('button .selected').text(value);
      }
      else
      {
        if (c3site.product.filter.text[name]) {
            th.parents('.btn-group').find('button .selected').text(c3site.product.filter.text[name]);
        }else{
            th.parents('.btn-group').find('button .selected').text(c3site.product.filter.text['default']);
        }
      }
  });
  
    $(document).on('change', '#facet input:checkbox', function(event) {
        var checkbox_name = $(this).attr('name');
        if (checkbox_name == 'checkbox_car_brand'
             || checkbox_name == 'checkbox_car_model'
             || checkbox_name == 'checkbox_car_year')
        {
            c3site.product.filter.update_car();
        }
        else
        {
            if (checkbox_name == 'checkbox_car_type')
            {
                $(this).closest( "fieldset" ).removeClass("selectionWaiting");
            }
            
            c3site.product.filter.clickElem = checkbox_name;
            c3site.product.filter.clickElemStatus = $(this).is(':checked');
            c3site.product.filter.update();  
        }
    });
  
    $(document).on('click', '#facet .filter_tab_list a', function(event) {
        var name = $(this).data('name');
        var value = $(this).data('value');
        var input = $(':hidden[name="' + name + '"]');
        if (input.val() == value) {
            input.val("");
            $(this).parent().removeClass("active");
        } else {
            input.val(value);               
        }
        c3site.product.filter.clickElem = name;
        c3site.product.filter.update();         
    });


  // SHOW ROZTEC DESCRIPTION ON HOVER
  $('.dropdown-car-details .fa-question-circle').hover(function() {
      $('.dropdown-car-details p').toggleClass('show');
  })


  // change product list view
  $( ".slider_products .product_list_options button" ).click(function() {
    var target = $(this).data("target"),
        list = $(this).closest(".slider_products");
    
    list.find(".products_list_slider").each(function() {
      $(this).hide();
      if($(this).data("target") == target) {
        $(this).show();
      }
    });
    list.find(".product_list_options button").each(function() {
      $(this).removeClass("active");
      if($(this).data("target") == target) {
        $(this).addClass("active");
      }
    });
  });



    // facet filter show products button
    $(document).on('click', '#btn-filter-load-products', function(e) {
        e.preventDefault();
        var hashparams = [
            c3site.product.filter.getParams(),
            c3site.product.filter.getParams("primary"),
            c3site.product.filter.getParams("secondary")
        ];
        c3site.product.list.load(hashparams);
    });


  //  SWIPEBOX INITIALIZE
  if($('.swipebox').length) {
    $('.swipebox').swipebox();
  }


  //---------------------------------------------//
  //           SLICK SLIDER INITIALIZE           //
  //---------------------------------------------//
  
  // homepage banner slider
  $("#homepage_slider").slick({
    dots: false,
    infinite: true,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  });

  // slider slider function for homepage products slider
  function slickInitialize(element) {
    $(element).slick({
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: "<button type='button' class='slick-prev'><span class='glyphicon glyphicon-chevron-left' aria-hidden='true'></span></button>",
      nextArrow: "<button type='button' class='slick-next'><span class='glyphicon glyphicon-chevron-right' aria-hidden='true'></span></button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            arrows: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            arrows: false
          }
        }
      ]
    });
  }

  // homepage products slider
  if(!($('.product-detail').length)) {
    $(".products_list_slider").each(function() {
      var target = $(this).attr('data-target');
  
      if(target == 'slider_box1-sale' || target == 'slider_box2-sale' || target == 'slider_box3-sale') {
        slickInitialize(this);
      }
    })
  
    // initialize slick slider after slides are displayed
    $('.product_list_options button').one('click', function() {
      var target = $(this).attr('data-target');
      
      if(target == 'slider_box1-new' || target == 'slider_box2-new') {
        $('.products_list_slider').each(function() {
          if($(this).data('target') == target) {
            slickInitialize(this);
          }
        });
      }
    });
  }


  // homepage brands slider
  $("#brands_slider").slick({
    infinite: true,
    slidesToShow: 6,
    autoplay: true,
    prevArrow: "<button type='button' class='slick-prev'><span class='glyphicon glyphicon-chevron-left' aria-hidden='true'></span></button>",
    nextArrow: "<button type='button' class='slick-next'><span class='glyphicon glyphicon-chevron-right' aria-hidden='true'></span></button>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          arrows: false
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          arrows: false
        }
      }
    ]
  });

  // product crosssale slider
    alternativesSlider('.products-crosssale.slider-1');
    alternativesSlider('.products-crosssale.slider-2');
    alternativesSlider('.products-crosssale.slider-3');

	function alternativesSlider(element) {
		var slides_to_show = 5;

		$(element).slick({
			dots: false,
			slidesToShow: slides_to_show > $(element).children().length ? $(element).children().length : 5,
			slidesToScroll: 1,
			prevArrow: "<button type='button' class='slick-prev'><span class='glyphicon glyphicon-chevron-left' aria-hidden='true'></span></button>",
			nextArrow: "<button type='button' class='slick-next'><span class='glyphicon glyphicon-chevron-right' aria-hidden='true'></span></button>",
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: slides_to_show > $(element).children().length ? $(element).children().length : 4
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: slides_to_show > $(element).children().length ? $(element).children().length : 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: slides_to_show > $(element).children().length ? $(element).children().length : 3,
						arrows: false
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: slides_to_show > $(element).children().length ? $(element).children().length : 2,
						arrows: false
					}
				},
				{
					breakpoint: 390,
					settings: {
						slidesToShow: 1,
						arrows: false
					}
				}
			]
		});
	}

  // product detail gallery slider 
  $("#products_gallery").slick({
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev'><span class='glyphicon glyphicon-chevron-left' aria-hidden='true'></span></button>",
    nextArrow: "<button type='button' class='slick-next'><span class='glyphicon glyphicon-chevron-right' aria-hidden='true'></span></button>",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 7
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  });


  //-----------------------------------------------//
  //           article detail fixed img            //
  //-----------------------------------------------//
  // set variables
  var header = $('header'),
      article = $('.article'),
      articleImg = $('.article__img'),
      articleImgHeight = articleImg.height(),
      headerHeight = header.height() + parseInt(27),
      vTop = article.length ? article.offset().top : 0,
      vBottom = vTop + article.height(),
      yOffset = parseInt(40);

  $(window).on('scroll', function () {

    // scroll position of window top
    var y = $(this).scrollTop();


  });

  $(window).on('resize', function() {
            
    $(window).on('scroll', function () {

      // scroll position of window top
      var y = $(this).scrollTop();


    });
  });

  //-------------------------------------------//
  //           show facet on click            //
  //-------------------------------------------//
  var facetFilter_btn = $('.show-filter'),
      facetFilter_content = $('.filter_section'),
      facetFilter_show = $('#btn-filter-load-products');

  const mainEl = document.querySelector("main");
  let isFacetVisible = facetFilter_btn.is(".open");

  hideFacetFilter = (that) => {
    $(that).toggleClass('open');
    facetFilter_content.slideToggle('fast');
    isFacetVisible = !isFacetVisible;
  }

  function getPosition(el) {
    let [top, left] = [0, 0];

    do {
      top += el.offsetTop - el.scrollTop;
      left += el.offsetLeft - el.scrollLeft;
    } while ( el = el.offsetParent );

    return { top, left };
  }

  facetFilter_btn.on('click', function() {
    hideFacetFilter(this);

    if (isFacetVisible && $(".sticky-rozsireny-filter").is(".sticked")) {
      const top = getPosition(mainEl).top;
      window.scrollTo({
        top,
        behavior: "smooth" 
      });
    }
  });

  if ($('.show-filter').is(':visible')) {
    facetFilter_show.on('click', function() {
      hideFacetFilter(this);
      $("html").scrollTop(0);
    });
  }
  //-----------------------------------------------//
}); 

// CAR SEARCH ON POPUP FILTER
function carSearch() {
    var filter = $('#search_input').val().toUpperCase();
    $.each($('#car_search_results li'), function() {
        var li = $(this);
        var content = li.data("value").toUpperCase();
        // if input not contains diacritics, but it could be in list
        if(!filter.match(/[á-žÁ-Ž]+/g)) {
            filter = removeDiacritics(filter);
            content = removeDiacritics(content);
        }
        if(content.indexOf(filter) > -1) {
            li.show();
        } else {
           li.hide();
        }        
    });
}

// remove diacritics function
function removeDiacritics(str){
    let diacritics = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    let diacriticsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
    str = str.split('');
    str.forEach((letter, index) => {
        let i = diacritics.indexOf(letter);
        if (i != -1) {
            str[index] = diacriticsOut[i];
        }
    })
    return str.join('');
}


// CHANGE FILTER AFTER CLICK
function changeFilter() {
    $('.filter-popup').fadeOut('500');
    $('.filter-background').fadeOut('500');
    // SCROLL TO ROZSIRENY FILTER
    $('html, body').animate({
        scrollTop: $(".filter_rozsireny").offset().top
    }, 500);
    $('.filter_rozsireny').addClass('blink');
    setTimeout(function(){
        $('.filter_rozsireny').removeClass('blink');
    },2500);
}

// CHANGE FILTER AFTER CLICK
function changeFilterTop() {
    $('.filter-popup').fadeOut('500');
    $('.filter-background').fadeOut('500');
    // SCROLL TO TOP LEFT FILTER
    $('html, body').animate({
        scrollTop: $(".filter_automobil").offset().top
    }, 500);
    $('.filter_automobil').addClass('light-blink');
    setTimeout(function(){
        $('.filter_automobil').removeClass('light-blink');
    },2500);
}

function showPopup() {
    $('.filter-background, .snehove_retaze_filter').fadeIn(100);
}

// LOADING FILTER ANIMATION WITH SPINNER
function filterLoad(elementToHide, delay, elementToShow) {
    $(elementToHide).hide();
    $('.disky_na_automobil_filter').append('<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>');
    setTimeout(function() {
        $('.fa-spin').remove();
        $(elementToShow).show();
    }, delay);
};

// FULL TABLE ROW CLICKABLE
function rowClick(elem) {
    if (event.target.type !== 'checkbox') {
        $(':checkbox', elem).trigger('click');
    }
}

// CHECKED ONLY ONE CHECKBOX
function oneRow(elem) {
    $('input:checkbox').not(elem).prop('checked', false);
}

$(document).ready(function() {

  // TOGGLE SHOW MORE BUTTON
  $(document).on('click', '.showmore', function() {
    // set variables
    var tab = $(this).parent('.tab-pane'),
        btn = $(this);

    tab.toggleClass('open');
    btn.text('Zobraziť viac');
    if(tab.hasClass('open')) {
      btn.text('Zobraziť menej');
    } else {
        if($(window).width() <= 768) {
            $('html, body').animate({
                scrollTop: tab.offset().top - $('header').height() - 65
            });
        }
    }
  });

  $('.table-rozmery.disky a').mouseover(function() {
      var showClosestTr = $(this).closest('.main-tr').attr('data-tr');
      $('.disky tr.sub_' + showClosestTr).removeClass('hidden');
      $(this).closest('.main-tr').siblings().find('tr.sub').addClass('hidden');
  });
  $('.table-rozmery.disky a').click(function(e) {
      e.preventDefault();
  });
  
  $('.close-accessories').click(function(e) {
      e.preventDefault();
      var hideClosestTr = $(this).closest('tr').attr('class').split(' ').join('.').replace('.accessories', '');
      $('.disky tr.' + hideClosestTr).addClass('hidden');
      $('.disky tr.' + hideClosestTr).addClass('hidden');
  });
});


// add attach file name on bootstrap input type="file" form group
$(document).on('change', ':file.custom-file-input', function() {
  var input = $(this),
      numFiles = input.get(0).files ? input.get(0).files.length : 1,
      label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
      input.trigger('fileselect', [numFiles, label]);
});

// sort change
$(document).on('click', '#dropdown-sort-list a', function(event) {
    $('#dropdown-sort-list a').each(function() {
        $(this).removeClass("active");
    });
    $(this).addClass("active");
    c3site.pageData.sort = $(this).data("sort-value");
        
    var hashparams = [
      c3site.product.filter.getParams(),
      c3site.product.filter.getParams("primary"),
      c3site.product.filter.getParams("secondary")
    ];
    c3site.product.list.load(hashparams);
});

$(document).ready( function() {
  $(':file.custom-file-input').on('fileselect', function(event, numFiles, label) {

    var input = $(this).parents('.input-group').find(':text'),
        log = numFiles > 1 ? numFiles + ' files selected' : label;

    if(input.length) {
        input.val(log);
    }

  });

  // SHOW MOBILE SEARCH BOX AFTER CLICK
  // set variables
  var searchBox = $('.search-box');

  $('.btn-search-mobile').on('click', function() {
    searchBox.fadeIn('fast').find('input').focus();
  });

  // HIDE MOBILE SEARCH BOX AFTER CLICK
  $('.search-close').on('click', function() {
    searchBox.hide();
  });


    // COMPARE PRODUCTS
    $('.compare__sidebar li').on('mouseover', function() {
        var elIndex = $(this).index();
        $(this).addClass('line_hover');
        
        $('.compare__product li').each(function() {
            var elResult = $(this).find('div:nth-child(' + (elIndex + 1) + ')');
            elResult.addClass('line_hover');
        });
    });

    $('.compare__sidebar li').on('mouseout', function() {
        var elIndex = $(this).index();
        $(this).removeClass('line_hover');

        $('.compare__product li').each(function() {
            var elResult = $(this).find('div:nth-child(' + (elIndex + 1) + ')');
            elResult.removeClass('line_hover');
        });
  });


  // show/hide information box on hover
  function showHideInfo() {
    if($('.grid-border').length) {
      $(document).on('mouseover', '.grid-border .hidingcontent', function() {
        var isEl = $(this).find('.hodnotenie_konfort');
  
        if(isEl.length > 0) {
          $(this).find('.information_box, .show-more-details').hide();
          isEl.css('display', 'inline-flex');
        }
      });
      $(document).on('mouseleave', '.grid-border .hodnotenie_konfort', function() {
        if($(this).length > 0) {
          $(this).next('.show-more-details').show();
          $(this).prev('.information_box').css('display', 'flex');
          $(this).hide();
        }
      });
      $(document).on('mouseleave', '.grid-border .product-item', function() {
        $(this).find('.show-more-details').show();
        $(this).find('.information_box').css('display', 'flex');
        $(this).find('.hodnotenie_konfort').hide();
      });
    } else if($('.products_list_slider').length) {
      $(document).on('mouseover', '.products_list_slider .hidingcontent', function() {
        var isEl = $(this).find('.hodnotenie_konfort');
  
        if(isEl.length > 0) {
          $(this).find('.information_box, .show-more-details').hide();
          isEl.css('display', 'inline-flex');
        }
      });
      $(document).on('mouseleave', '.products_list_slider .hodnotenie_konfort', function() {
        if($(this).length > 0) {
          $(this).next('.show-more-details').show();
          $(this).prev('.information_box').css('display', 'flex');
          $(this).hide();
        }
      });
      $(document).on('mouseleave', '.products_list_slider .product-item', function() {
        $(this).find('.show-more-details').show();
        $(this).find('.information_box').css('display', 'flex');
        $(this).find('.hodnotenie_konfort').hide();
      });
    };
  }
  
  showHideInfo();

  $(document).on('click', '.product_list_options button', function() {
    $('.product_list_options button').removeClass('active');
    $(this).addClass('active');
    c3site.pageData.listing_mode = $(this).data("listing-mode");    
    var hashparams = [
      c3site.product.filter.getParams(),
      c3site.product.filter.getParams("primary"),
      c3site.product.filter.getParams("secondary")
    ];
    c3site.product.list.load(hashparams);

    if(c3site.pageData.listing_mode == 'grid') {
      $(document).find('.product-list').removeClass('standard').addClass('pneu-grid grid-border');
      showHideInfo();
    } else {
      $(document).find('.product-list').removeClass('pneu-grid grid-border').addClass('standard');
    }
  });


  /////////////////////////////////////////////////
  ////          ajax loading articles          ////
  /////////////////////////////////////////////////

    // check if there is one more article to load
    function checkMoreItems() {    
        $.ajax({
            url: cyclone3.domain + '/service/chunk_article_list',
            type: 'POST',
            data: {
                id: cyclone3.news_category,
                limit: 1,
                offset: $('.news__item').length
            },
            dataType: 'html',
        })
        .done(function(data) {
            // find ajax items
            var items = $(data).find('#more-news').children();
    
            // remove load more button
            if(items.length == 0) {
                $('#load-more-articles').remove();
            }
        })
        .fail(function(e) {
            console.error(e);
        });
    }

    // init function on document ready
    //checkMoreItems();

    // load more articles on click
    $('#load-more-articles').on('click', function() {
        
        console.log("load-more-articles");
        var loadingIcon = $('<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>');
        
        // add loading icon after click
        $(this).addClass('loading').append(loadingIcon);
        
        $.ajax({
            url: cyclone3.domain + '/service/chunk_article_list',
            type: 'POST',
            data: {
                id: cyclone3.news_category,
                limit: cyclone3.sql_limit,
                offset: $('.news__item').length
            },
            dataType: 'html',
        })
        .done(function(data) {        
            // find ajax items
            var items = $(data).find('#more-news').children();            
            // append div with items
            $('.articles-wrapper').append(items);            
            // remove loading button
            $('#load-more-articles').removeClass('loading').find(loadingIcon).remove();
            
            checkMoreItems();
        })
        .fail(function(e) {
            console.error(e);
        });
    });
    //////////////////////////////////////////////////////////
    ////          / end of ajax loading articles          ////
    //////////////////////////////////////////////////////////
    

    //
    // custom accordion switcher
    //
    if (('.custom__accordion').length) {
      $('.custom__accordion').on("click", function(e) {
        if (!e.target.closest('.product-price__button')) {
          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
          } else {
            $('.custom__accordion').each(function(){
              $(this).removeClass('active')
            })
            $(this).addClass('active');
          }
        }
      })
    }
    
    // chain add to cart variant select by hash 
    if ($('#product_variant').length) {
        if (window.location.hash){
            var hash = window.location.hash.substr(1);
            var variant_arr = hash.split("-");
            var variant;
            if (variant_arr[0] != "") {
                variant = variant_arr[0];
            }
            if (variant_arr[1] != "") {
                variant += "/"+variant_arr[1];
            }
            if (variant_arr[2] != "") {
                variant += " "+variant_arr[2];
            }
            $('#product_variant option[value="' + variant + '"]').prop('selected', true);				
        }
    }
    
});